var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { TreeSelect as ANTtreeSelect } from "antd";
import "antd/dist/antd.css";
import "./treeSelect.styles.scss";
var SHOW_PARENT = ANTtreeSelect.SHOW_PARENT;
var TreeSelect = function (props) {
    var label = props.label, required = props.required, tree = props.tree;
    /**
     * derived state: why?
     * to provide initial state to multi select, but the onChange method only gives
     * the changed or added chip, instead of the complete state of the antd tree select,
     * hence to maintain a complete state of tree select, a state variable 'value' is used here.
     */
    var initialValues = [];
    var _a = React.useState(initialValues), value = _a[0], setValue = _a[1];
    /**
     * refreshes derived state with changes in props.
     */
    React.useEffect(function () {
        setValue(props.value || []);
    }, [props.value]);
    var onChange = function (value) {
        var onChipSelect = props.onChipSelect;
        setValue(value);
        var codeList = getCodeList(value);
        onChipSelect && onChipSelect(codeList);
    };
    var getCodeList = function (values) {
        return values.map(function (value) { return ({ value: value }); });
    };
    var tProps = __assign({ value: value,
        onChange: onChange, treeData: tree, treeCheckable: true, showCheckedStrategy: SHOW_PARENT, searchPlaceholder: "Please select", treeNodeFilterProp: "title", style: {
            width: "100%",
        } }, props);
    return (React.createElement("div", { className: "chip-select-container" },
        label && (React.createElement("label", { className: "label" },
            label,
            React.createElement("span", { className: "required-indicator" }, required ? "*" : ""))),
        React.createElement(ANTtreeSelect, __assign({}, tProps))));
};
export default TreeSelect;
//# sourceMappingURL=treeSelect.js.map